import React from 'react'
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import URLConfig from '@Config/urls/url.config';
import { FaArrowLeft } from 'react-icons/fa';

const tabHeaders = [
  'Client',
  'Demandeur',
  'Adresse\u{202F}\u{202F}demandeur',
  'Adresse\u{202F}\u{202F}Correspondance',
  'Langages',
  'Biens\u{202F}\u{202F}et\u{202F}\u{202F}revenus', // \u{202F} = code js caractère insécable
  'Dette\u{202F}\u{202F}en\u{202F}\u{202F}suspens',
  'Documents\u{202F}\u{202F}Requis',
  'Mémo',
];

const tabLinks = [
  'about',
  'applicant',
  'applicant-address',
  'correspondence-address',
  'languages',
  'assets-and-income',
  'outstanding-debt',
  'required-documents',
  'memo',
];

const CustomerDetailLayout = () => {
  const {pathname} = useLocation();
  const arr = pathname.split('/');
  const index = tabLinks.findIndex((value, index) => value === arr[arr.length - 1]);
  
  const orientation = CC.useBreakpointValue(
    { 
      base: 'horizontal', 
      "2xl": 'vertical', 
    }, 
    { 
      fallback: 'md', 
    }, 
  ) as "horizontal" | "vertical";
        
  const bg = CC.useColorModeValue('gray.400', 'whiteAlpha.700');

  return (
    <>
      
      {/* Back to previous page Section */}
      <CC.HStack>
        <Link
          to={
            URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_DATA_MENU.CUSTOMER
          }
        >
          <CC.Box
            borderRadius={'50%'}
            p={'0.5rem'}
            _hover={{ backgroundColor: `${bg}` }}
          >
            <FaArrowLeft size={'1.5rem'} />
          </CC.Box>
        </Link>

        <CC.Hide below="md">
          <CC.Heading size="lg">Consultation des Clients</CC.Heading>
        </CC.Hide>

        <CC.Show below="md">
          <CC.Heading size="lg">Retour</CC.Heading>
        </CC.Show>
      </CC.HStack>

      <CC.Divider my={'2rem'} />

      <CC.Heading size="md" ml={8}>Client Porteur</CC.Heading>

      <CC.Tabs orientation={orientation} isLazy defaultIndex={index} px={{ base: "1rem", xl: '2rem'}} mt={"2rem"}>
        <CC.Box as={"div"} style={{ overflow: 'auto' }} minW={'15%'} mt={'1.2rem'}>
          <CC.TabList  alignItems={"flex-start"}>
            {tabHeaders.map((tab, index) => (
              <NavLink to={tabLinks[index]} key={index}>
                <CC.Tab _hover={{ textColor: `${CC.useColorModeValue('black.50', 'red.50')}`, backgroundColor: `${CC.useColorModeValue('blue.50', 'blue.600')}`, borderRadius: "5px" }}>
                  {tab}
                </CC.Tab>
              </NavLink>
            ))}
          </CC.TabList>
        </CC.Box>

        <CC.TabPanels>
          {tabHeaders.map((_, index) => (
            <CC.TabPanel key={index}>
              <Outlet />
            </CC.TabPanel>
          ))}
        </CC.TabPanels>
      </CC.Tabs>
    </>
  );
}

export default CustomerDetailLayout